export const jobFairFormField = [
	{
		type: 'hidden',
		formControlName: 'id',
	},
	{
		type: 'text',
		title: 'Title (character limit 200)',
		placeholder: 'Enter Title',
		formControlName: 'title',
		required: true,
		maxLength: 200,
		errorsMsg: [
			{ type: 'required', message: 'Title is required' },
			{
				type: 'maxlength',
				message: 'Title should be less than 200 characters',
			},
		],
	},
	{
		type: 'text',
		title: 'Typeform Name (character limit 200)',
		placeholder: 'Enter typeform Name',
		formControlName: 'name',
		required: true,
		maxLength: 200,
		errorsMsg: [
			{ type: 'required', message: 'Name is required' },
			{
				type: 'maxlength',
				message: 'Typeform Name should be less than 200 characters',
			},
		],
	},
	{
		type: 'text',
		title: 'Subheading (character limit 500)',
		placeholder: 'Subheading',
		formControlName: 'description',
		maxLength: 500,
		required: true,
		errorsMsg: [
			{ type: 'required', message: 'Sub Heading is required' },
			{
				type: 'maxlength',
				message: 'Typeform Name should be less than 500 characters',
			},
		],
	},
	{
		type: 'url',
		title: 'Event Link',
		placeholder: 'eventUrl',
		formControlName: 'eventUrl',
		required: true,
		errorsMsg: [
			{ type: 'required', message: 'eventUrl is required' },
			{ type: 'pattern', message: 'Please enter a valid URL' },
		],
	},
	{
		type: 'datetime-local',
		title: 'Start Date (Please use your local timezone)',
		placeholder: 'Start Date',
		formControlName: 'jobFairDate',
		required: true,
		errorsMsg: [
			{ type: 'required', message: 'JobFair Start Date is required' },
		],
	},
	{
		type: 'datetime-local',
		title: 'End Date (Please use your local timezone)',
		placeholder: 'End Date',
		formControlName: 'endDate',
		required: true,
		dateRangeValidator: 'jobFairDate',
		errorsMsg: [
			{ type: 'required', message: 'JobFair End Date is required' },
			{
				type: 'dateRangeValidator',
				message: 'End time is less than start time',
			},
		],
	},
	{
		type: 'toggle',
		title: 'visible',
		placeholder: 'visible',
		formControlName: 'visible',
		size: 6,
	},
	{
		type: 'hidden',
		formControlName: 'isActive',
	},
	{
		type: 'toggle',
		title: 'enableNotification',
		placeholder: 'enableNotification',
		formControlName: 'enableNotification',
		size: 6,
	},
	{
		type: 'toggle',
		title: 'scheduleFinalised',
		placeholder: 'scheduleFinalised',
		formControlName: 'scheduleFinalised',
		size: 6,
	},
	{
		type: 'toggle',
		title: 'isEpp', // isEpp
		placeholder: 'isEpp',
		formControlName: 'isEpp',
		size: 6,
	},
	{
		type: 'text',
		title: 'Who can Join(character limit 200)', // canjoin
		placeholder: 'Who can Join',
		formControlName: 'canJoin',
		required: true,
		maxLength: 200,
		errorsMsg: [
			{ type: 'required', message: 'Who can Join is required' },
			{
				type: 'maxlength',
				message: 'Who can Join should be less than 200 characters',
			},
		],
	},
	{
		type: 'text',
		title: 'Notification Title (character limit 500)',
		placeholder: 'Notification Title',
		formControlName: 'notificationTitle',
		required: true,
		maxLength: 500,
		errorsMsg: [
			{ type: 'required', message: 'Notification Title is required' },
			{
				type: 'maxlength',
				message: 'Notification Title should be less than 500 characters',
			},
		],
	},
	{
		type: 'text',
		title: 'Notification Subtitle (character limit 500)',
		placeholder: 'Notification Subtitle',
		formControlName: 'notificationTitle1',
		required: true,
		maxLength: 500,
		errorsMsg: [
			{ type: 'required', message: 'Notification Title is required' },
			{
				type: 'maxlength',
				message: 'Notification Title should be less than 500 characters',
			},
		],
	},
	{
		type: 'url',
		title:
			'User registration typeform (optional: only needed when we want to open a typeform after RSVP)',
		placeholder: 'Please enter typeform link',
		formControlName: 'typeForm',
		errorsMsg: [{ type: 'pattern', message: 'Please enter a valid URL' }],
	},
	{
		type: 'url',
		title: 'SlotSelectionLink(google calendar invite link for networking slot)', // SlotSelectionLink
		placeholder: 'Please enter SlotSelectionLink',
		formControlName: 'slotSelectionLink',
		errorsMsg: [{ type: 'pattern', message: 'Please enter a valid URL' }],
	},
	{
		type: 'select',
		title:
			'Timezone (Use the timezone which corresponds to where the event is being organized)',
		placeholder: 'select Timezone',
		formControlName: 'timeZone',
		required: true,
		errorsMsg: [{ type: 'required', message: 'select Timezone' }],
	},
	{
		type: 'select',
		title: 'Location',
		placeholder: 'select Location',
		formControlName: 'location',
		required: true,
		errorsMsg: [{ type: 'required', message: 'select Location' }],
	},
	{
		type: 'toggle',
		title: 'Virtual',
		formControlName: 'virtual',
		size: 6,
	},
	{
		type: 'text',
		title: 'Cost',
		placeholder: 'cost',
		formControlName: 'cost',
	},
	{
		type: 'select',
		title: 'Partnership Company',
		placeholder: 'select Partnership Company',
		formControlName: 'partnershipCompany',
		errorsMsg: [{ type: 'required', message: 'select Partnership Company' }],
	},
	{
		type: 'select',
		title: 'Job Function',
		placeholder: 'select Job Function',
		formControlName: 'jobFunction',
		errorsMsg: [{ type: 'required', message: 'select Job Function' }],
	},
];
